import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_ACTIVIDAD_BARRERA_BRUTO } from '../../../../../../config/tables'

function TablaRegistroActividadBarreraBrutoView () {
  return (<MuiTable id={TABLA_ACTIVIDAD_BARRERA_BRUTO} />)
}

export default TablaRegistroActividadBarreraBrutoView
